// Domain redirection logic
(function() {
  const local=Shopify.country?.toLowerCase();

  
  
  const currentHostname = window.location.hostname;
  const currentPath = window.location.pathname;
  const searchParams = window.location.search;
  
  // // Domain mappings
  const domains = {
    nl: 'dubaichocolates.nl',
    store: 'dubaichocolates.store'
  };



  
  // Function to handle domain redirection
  function handleDomainRedirect() {
    // Get country from Shopify
    // const userCountry = local; // Default to NL if not set
    
    // If user is from Netherlands
    if (local == 'nl') {
      // If not on NL domain, redirect to NL domain
      if (currentHostname !== domains.nl) {
        window.location.href = `https://${domains.nl}${currentPath}${searchParams}`?.replace("/en","");
      }
    } else {
      // For all other countries, redirect to store domain if not already there
      if (currentHostname !== domains.store) {
        window.location.href = `https://${domains.store}${currentPath}${searchParams}`;
      }
    }
  }

  // handleDomainRedirect()

  // // Execute when the page loads
  // document.addEventListener('DOMContentLoaded', handleDomainRedirect);
})(); 